import { render } from "./SelectedWonder.vue?vue&type=template&id=7ee12b00"
import script from "./SelectedWonder.vue?vue&type=script&lang=js"
export * from "./SelectedWonder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__